import React from "react";
import styles from "./AccountBlocked.module.scss";

const AccountBlocked = () => {
  return (
    <div className={styles["account-blocked"]}>
      <p>
        Уважаемый пользователь, мы хотим сообщить вам, что ваш аккаунт был
        временно заблокирован. Это могло произойти по ряду причин, включая
        возможные нарушения наших условий использования или необычную
        активность, которая может указывать на безопасность вашего аккаунта.
        Пожалуйста, свяжитесь с нашей службой поддержки для получения
        дополнительной информации и следующих шагов по восстановлению доступа к
        вашему аккаунту. Мы ценим ваше понимание и готовы помочь вам в решении
        этой ситуации.
      </p>
    </div>
  );
};

export default AccountBlocked;
